module.exports = __webpack_public_path__ + "static/media/carlous-img2.bec07be2.jpg";